import React, { useState, useEffect, useCallback, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Typography, CircularProgress, Button } from "@material-ui/core";
import { useLocation, useHistory } from "react-router-dom";
import { activateUser } from "../API/User";
import { LangContext } from "../Context/Langcontext";

const useStyle = makeStyles((theme) => ({
  viewBg: {
    height: "100vh",
    backgroundColor: "#E5EAEE",
  },
  middle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  center: { display: "flex", justifyContent: "center", position: "relative" },
  circleProcess: { position: "absolute", top: 70 },
  fixTop: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100vw",
  },
  fullHeight: { height: "100%" },
  btn: { borderRadius: 8 },
  font: { fontWeight: 400 },
}));

const Activate = () => {
  const classes = useStyle();
  const [message, setmessage] = useState("กำลังยืนยันบัญชีของคุณ");
  const [message2, setmessage2] = useState("โปรดรอสักครู่");
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;

  const activeuser = useCallback(async () => {
    const searchText = location.search;
    const codeParam = new URLSearchParams(searchText).get("code");
    const emailParam = new URLSearchParams(searchText).get("email");
    const input = { email: emailParam, activate_code: codeParam };

    if (typeof codeParam === "string") {
      const active = await activateUser(input);
      if (active.status.code === 200) {
        setTimeout(() => {
          setmessage("ยืนยันบัญชีของคุณเรียบร้อยแล้ว");
          setmessage2("");
          setLoading(true);
        }, 2000);
      } else {
        setTimeout(() => {
          setmessage("บัญชีของคุณถูกยืนยันแล้ว");
          setmessage2("");
          setLoading(true);
        }, 2000);
      }
    } else {
      history.replace("/user/signin");
    }
  }, [location, history]);

  useEffect(() => {
    activeuser();
    return () => {};
  }, [activeuser]);

  React.useEffect(() => {
    document.title = `${lang.Activate} | ${lang.MEAtitle}`;
    return () => {};
  }, [lang]);

  return (
    <div className={clsx(classes.middle, classes.viewBg)}>
      <div className={classes.center}>
        <div style={{ marginTop: "1rem" }}>
          <Typography align="center" className={classes.font}>
            {message}
          </Typography>
          {!loading ? (
            <Typography align="center" className={classes.font}>
              {message2}
            </Typography>
          ) : null}
        </div>
        {loading ? (
          <div className={classes.circleProcess}>
            <Button
              variant="contained"
              color="primary"
              size="medium"
              onClick={() => {
                history.replace("/user/login");
              }}
              className={classes.btn}
            >
              {lang.Signin}
            </Button>
          </div>
        ) : null}
        {!loading ? (
          <CircularProgress
            className={classes.circleProcess}
            size={50}
            thickness={2}
            color="primary"
          />
        ) : null}
      </div>
    </div>
  );
};

export default Activate;
